import { gql } from "@apollo/client";

export const IdentificationFragment = gql`
  fragment identificationFragment on Identification {
    id
    documentId
    firstName
    images {
      id
      name
      side
      url
    }
    isPrimary
    lastName
    location {
      id
      address1
      address2
      city
      country
      state
      zip
    }
    phone
  }
`;
